function formatDurationMS(value) {
	value = Math.round(value)
	const minutes = Math.floor(value / 60)
	const seconds = value - minutes * 60
	return minutes+':'+(seconds<10?'0':'')+seconds
}

function formatDurationHMS(value) {
	value = Math.round(value)
	const hours = Math.floor(value / 60 / 60)
	const minutes = Math.floor((value - hours * 60 * 60) / 60)
	const seconds = value - hours * 60 * 60 - minutes * 60
	return hours+':'+(minutes<10?'0':'')+minutes+':'+(seconds<10?'0':'')+seconds
}

function formatDurationMSOrHMS(value) {
	if (value >= 60*60) return formatDurationHMS(value)
	else return formatDurationMS(value)
}

function normalizeString(str) {
	str = str.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase()
	let str1 = str.replace(/[^a-z0-9 ]/g, '').replace(/ +/g, ' ').trim()
	let str2 = str.replace(/[^a-z0-9 ]/g, ' ').replace(/ +/g, ' ').trim()
	if (str1 === str2) return [str1]
	else return [str1, str2]
}

function shuffle(array) {
	array.sort(function() {
		return Math.random() - 0.5
	})
}

let Util = {
	formatDurationMS: formatDurationMS,
	formatDurationHMS: formatDurationHMS,
	formatDurationMSOrHMS: formatDurationMSOrHMS,
	normalizeString: normalizeString,
	shuffle: shuffle
}

export default Util
